import { initialize as initializeDataTypes, Kinds, TypeInfos } from "../../lib/data/model/data-types.js";

const TYPE_DEFS = [
        ['Setting', 'Setting', null, null, null],
        ['TimeZone', 'Time Zone', null, null, 'core/time-zones/codelist'],
        ['Locale', 'Locale', null, null, 'core/locales/codelist'],
        ['User', 'User', null, null, 'core/users/codelist'],
        ['Privilege', 'Privilege', null, null, 'core/privileges/codelist'],
        ['Role', 'Role', null, null, 'core/roles/codelist'],
        ['RolePrivilege', 'Role Privilege', null, null, null],
        ['UserRole', 'User Role', null, null, null],
        ['Permission', 'Privilege', null, null, 'core/permissions/codelist'],
        ['FolderType', 'Folder Type', null, null, 'core/folder-types/codelist'],
        ['Folder', 'Folder', null, null, null],
        ['FolderPermission', 'Folder Permission', null, null, null],
        ['FileType', 'File Type', null, null, 'core/file-types/codelist'],
        ['File', 'Soubor', null, null, null],
        ['Workflow', 'Workflow', null, null, null],
        ['WorkflowStatus', 'Workflow State', null, null, null],
        ['WorkflowTransition', 'Workflow Transition', null, null, null],
        ['WorkflowTransitionPrivilege', 'Workflow Transition Privilege', null, null, null],
        ['Quantity', 'Measurement Quantity', null, null, 'measurements/quantities/codelist'],
        ['Unit', 'Measurement Unit', null, null, 'measurements/units/codelist'],
        ['ProjectType', 'Project Type', null, null, 'projects/project-types/codelist'],
        ['Project', 'Project', null, null, null],
        ['ProjectStageType', 'Project Stage Type', null, null, 'projects/project-stage-types/codelist'],
        ['Workspace', 'Workspace', null, null, null],
        ['WorkspaceRole', 'Workspace Role', null, null, 'projects/workspace-roles/codelist'],
        ['WorkspaceProject', 'Workspace Project', null, null, null],
        ['CodeStandardDocumentType', 'Cds Type', null, null, 'standards/code-standard-document-types/codelist'],
        ['CodeStandardDocument', 'Code Standard Document', null, null, null],
        ['ConstructionMethod', 'Construction method', null, null, 'sites/construction-methods/codelist'],
        ['SiteType', 'Site Type', null, null, 'sites/site-types/codelist'],
        ['Site', 'Site', null, null, 'sites/sites/codelist'],
        ['LocationType', 'Location Type', null, null, 'sites/location-types/codelist'],
        ['Location', 'Location (Object)', null, null, 'sites/locations/codelist'],
        ['StoredModelSection', 'Stored Model Section', null, null, null],
        ['ModelSection', 'Model Section', null, null, null],
        ['ModelInterval', 'Model Interval', null, null, null],
        ['GeoBoundaryType', 'Boundary Type', null, null, 'model-sections/geo-boundary-types/codelist'],
        ['GeoBoundary', 'Section Boundary', null, null, null],
        ['GeoLoadType', 'Load Type', null, null, 'model-sections/geo-load-types/codelist'],
        ['GeoLoadDirectionType', 'Load Direction Type', null, null, 'model-sections/geo-load-direction-types/codelist'],
        ['GeoLoad', 'Load', null, null, null],
        ['GeoObjectKind', 'Object Kind', null, null, 'model-sections/geo-object-kinds/codelist'],
        ['GeoObjectType', 'Object Type', null, null, 'model-sections/geo-object-types/codelist'],
        ['GeoObject', 'Object', null, null, null],
        ['GeoObjectTbm', 'Object Tbm', null, null, null],
        ['GeoObjectTbmBoundary', 'Tbm Level', null, null, null],
        ['GeoObjectTbmSensor', 'Tbm Face Pressure Sensor', null, null, null],
        ['WaterSurfaceStressCalculationMethod', 'Water Surface Stress Calc Method', null, null, 'geo-sections/water-surface-stress-calculation-methods/codelist'],
        ['PiezometricHeadCalculationMethod', 'Piezometric Head Calc Method', null, null, 'geo-sections/piezometric-head-calculation-methods/codelist'],
        ['K0CalculationMethod', 'K 0 Method', null, null, 'geo-sections/k-0-calculation-methods/codelist'],
        ['BulkUnitWeightGamaCalculationMethod', 'Bulk Unit Weight Gama Calc Method', null, null, 'geo-sections/bulk-unit-weight-gama-calculation-methods/codelist'],
        ['MinBulkUnitWeightGamaMinCalculationMethod', 'Min Bulk Unit Weight Gama Min Calc Method', null, null, 'geo-sections/min-bulk-unit-weight-gama-min-calculation-methods/codelist'],
        ['SaturatedUnitWeightGamaSatCalculationMethod', 'Saturated Unit Weight Gama Sat Calc Method', null, null, 'geo-sections/saturated-unit-weight-gama-sat-calculation-methods/codelist'],
        ['SubmergedUnitWeightGamaSubCalculationMethod', 'Submerged Unit Weight Gama Sub Calc Method', null, null, 'geo-sections/submerged-unit-weight-gama-sub-calculation-methods/codelist'],
        ['MinSubmergedUnitWeightGamaSubMinCalculationMethod', 'Min Submerged Unit Weight Gama Sub Min Calc Method', null, null, 'geo-sections/min-submerged-unit-weight-gama-sub-min-calculation-methods/codelist'],
        ['DryUnitWeightGamaDCalculationMethod', 'Dry Unit Weight Gama D Calc Method', null, null, 'geo-sections/dry-unit-weight-gama-d-calculation-methods/codelist'],
        ['UnitWeightOfSolidsGamaSCalculationMethod', 'Unit Weight Of Solids Gama S Calc Method', null, null, 'geo-sections/unit-weight-of-solids-gama-s-calculation-methods/codelist'],
        ['MinUnitWeightOfSolidsGamaSMinCalculationMethod', 'Min Unit Weight Of Solids Gama S Min Calc Method', null, null, 'geo-sections/min-unit-weight-of-solids-gama-s-min-calculation-methods/codelist'],
        ['DegreeOfSaturationSrCalculationMethod', 'Degree Of Saturation Sr Calc Method', null, null, 'geo-sections/degree-of-saturation-sr-calculation-methods/codelist'],
        ['MoistureContentWCalculationMethod', 'Moisture Content W Calc Method', null, null, 'geo-sections/moisture-content-w-calculation-methods/codelist'],
        ['PlasticityIndexIpCalculationMethod', 'Plasticity Index Ip Calc Method', null, null, 'geo-sections/plasticity-index-ip-calculation-methods/codelist'],
        ['PorosityNCalculationMethod', 'Porosity N Calc Method', null, null, 'geo-sections/porosity-n-calculation-methods/codelist'],
        ['VoidRatioECalculationMethod', 'Void Ratio E Calc Method', null, null, 'geo-sections/void-ratio-e-calculation-methods/codelist'],
        ['SoilUnitWeightGamaCalculationMethod', 'Soil Unit Weight Gama Calc Method', null, null, 'geo-sections/soil-unit-weight-gama-calculation-methods/codelist'],
        ['GeoMassType', 'Mass Type', null, null, 'geo-sections/geo-mass-types/codelist'],
        ['ConsistencyType', 'Consistency Type', null, null, 'geo-sections/consistency-types/codelist'],
        ['RelativeDensityType', 'Relative Density Type', null, null, 'geo-sections/relative-density-types/codelist'],
        ['UcsType', 'Ucs Type', null, null, 'geo-sections/ucs-types/codelist'],
        ['TunnelOrientationType', 'Tunnel Orientation Type', null, null, 'geo-sections/tunnel-orientation-types/codelist'],
        ['GeoSection', 'Geo Section', null, null, null],
        ['GeoParams', 'Geo Param', null, null, null],
        ['GeoType', 'Geological Type', null, null, null],
        ['GeoLayer', 'Geological Layer', null, null, null],
        ['WaterBodyType', 'Water Body Type', null, null, 'geo-sections/water-body-types/codelist'],
        ['WaterBody', 'Water Body', null, null, null],
        ['EarthPressuresCalculation', 'Ps Calculation', null, null, null],
        ['EarthPressuresModelInterval', 'Ps Model Interval', null, null, null],
        ['EarthPressuresData', 'Primary Stress Result', null, null, null],
        ['KaCalculationMethod', 'Ka Method', null, null, 'face-pressures/ka-calculation-methods/codelist'],
        ['K1CalculationMethod', 'K 1 Method', null, null, 'face-pressures/k-1-calculation-methods/codelist'],
        ['K2CalculationMethod', 'K 2 Method', null, null, 'face-pressures/k-2-calculation-methods/codelist'],
        ['TrCalculationMethod', 'Tr Method', null, null, 'face-pressures/tr-calculation-methods/codelist'],
        ['FacePressuresCalculation', 'J S Calculation', null, null, null],
        ['FacePressuresModelInterval', 'J S Model Interval', null, null, null],
        ['FacePressuresGeotechData', 'J S Result', null, null, null],
        ['FacePressuresForcesData', 'J S Eremax Result', null, null, null],
        ['FacePressuresForcesAtAngle', 'J S Zeta Result', null, null, null],
        ['FacePressuresPressuresAtLevel', 'J S Pressure Result', null, null, null],
];

let $initialized = false;

export function initialize() {

    if ($initialized)
        return;

    initializeDataTypes();

    TYPE_DEFS.forEach((def, index) => {
        let type = {
            id: `${Kinds.Ref}:${def[0]}`,
            name: def[0],
            kind: Kinds.Ref,
            label: def[1],
            description: def[2],
            hint: def[3],
            valuesEndpoint: def[4],
        };
        TypeInfos.push(type);
    });

    $initialized = true;

};
